import { AccountEntityType } from 'constants/new_accounts.constants';

export const getCustomerWithTranslatedType = (accounts: any, t: any) => {
	const data = accounts.map((account: any) => {
		return {
			...account,
			entityType:
				account.entityType === AccountEntityType.COMPANY
					? t('customer.type.individual')
					: t('customer.type.corporate'),
		};
	});
	return data;
};
